import React from 'react';
import * as moment from 'moment';
import Box from '@mui/material/Box';
import PlanField from 'components/PlanField';
import AlertAlt from 'components/AlertAlt';
import usePlan from 'hooks/usePlan';
import { useTeamContext } from 'contexts/useTeamContext';
import { Card, Title, Separator, PlanFieldContainer } from 'styles/components/planDetailsCard';

export default function JournalPlanDetails() {
  const [team] = useTeamContext();
  const [plan] = usePlan();

  return (
    <Card>
      <Title>{team.name} Member</Title>
      <Separator />

      {plan?.cancelAt && (
        <Box mt={3}>
          <AlertAlt icon={false} severity="default">
            Your plan has been <b>canceled</b> and will be changed to <b>Starter</b> on{' '}
            {moment.utc(plan.cancelAt).format('MM/DD/YYYY')}
          </AlertAlt>
        </Box>
      )}

      <PlanFieldContainer margin="20px 0">
        <PlanField icon="group_work" label="Publishers Group" value={team ? team.name : ''} />
      </PlanFieldContainer>

      {!plan?.cancelAt && (
        <AlertAlt icon={false} severity="default">
          You are a Journal subscription member and have all the benefits of it. Enjoy!
        </AlertAlt>
      )}
    </Card>
  );
}
